import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress, Typography } from '@mui/material';
import CustomDialog from 'components/CustomDialog/customDialog';
import CustomDialogHeader from 'components/CustomDialog/DialogHeader/dialogHeader.cmp';
import FlaggedItemsDetails from 'components/DataTables/Reports/FlaggedItems/FlaggedItemsDetails';
import { setDialog } from 'store/actions/dialogActions';
import { getDialogState } from 'store/selectors/dialogSelectors';
import xeniaApi from 'api/index';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';
import DIALOGS from 'utils/dialogIds';
import { useSubmissionsUtils } from 'utils/CustomHooks/useSubmissionsUtils';
import { ContentCnt, LoaderCnt } from './style';
import { SubmissionReportType } from 'pages/TemplateDashboard/Tabs/Submissions/context';
import LogDrawer from 'pages/Widgets/SubmissionsListing/LogDrawer';

function FlaggedItemsTableChartDialog() {
  const [tableData, setTableData] = useState<any>([]);
  const [activeLog, setActiveLog] = useState<SubmissionReportType>();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { transformaToFlaggedItems, transformaToFlaggedItemsQuestions } =
    useSubmissionsUtils();
  const { workspaceId } = useWorkspaceHook();
  const dialogState = useSelector(getDialogState);
  const state = dialogState?.[DIALOGS.FLAGGED_ITEMS_REPORT_CHART_BASED_DIALOG];

  const { open, data } = state;
  const { filters = null, title, type, itemId } = data;

  const handleClose = () => {
    dispatch(
      setDialog({
        open: false,
        dialogId: DIALOGS?.FLAGGED_ITEMS_REPORT_CHART_BASED_DIALOG,
      }),
    );
  };

  const fetchTaskList = async () => {
    const requestPayload = {
      ...filters,
    };
    const response = await xeniaApi.getAllChecklistLogs(requestPayload, true);
    let transformedData: any = [];
    if (type === 'question') {
      transformedData = transformaToFlaggedItemsQuestions(
        response?.data ?? [],
        itemId,
      );
    } else {
      transformedData = transformaToFlaggedItems(response?.data ?? []);
    }

    setTableData(transformedData ?? []);
    setLoading(false);
  };

  useEffect(() => {
    fetchTaskList();
  }, [filters]);

  const onRowClick = async (id: string) => {
    const log = await xeniaApi.getChecklistLog({
      logId: id,
      hotelId: workspaceId,
      filtered: true,
      sectioned: true,
    });
    if (log?.data) {
      setActiveLog(log.data);
    } else {
      setActiveLog(undefined);
    }
  };

  const handleArchiveApi = async (logs: any[]) => {
    const logIds = logs.map((log) => log.id);
    await xeniaApi.deleteChecklistLogs({
      checklistId: activeLog?.ChecklistId,
      hotelId: workspaceId,
      postData: {
        logIds,
      },
    });
    setTableData((prevData) =>
      prevData.filter((log) => !logIds.includes(log.id)),
    );
    setActiveLog(undefined);
  };
  return (
    <CustomDialog
      hideActions={true}
      header={
        <CustomDialogHeader onClose={handleClose}>
          <Typography
            fontWeight="700"
            fontSize="18px"
            lineHeight="24.59px"
            color="#000000"
          >
            {title}
          </Typography>
          {!loading && (
            <Typography
              fontWeight="800"
              fontSize="26px"
              lineHeight="35.52px"
              color="#000000"
            >
              {tableData?.length || 0}
            </Typography>
          )}
        </CustomDialogHeader>
      }
      dialogProps={{
        open: open,
        maxWidth: false,
        onClose: handleClose,
      }}
    >
      <ContentCnt>
        <LogDrawer
          open={!!activeLog}
          onClose={() => setActiveLog(undefined)}
          log={activeLog as SubmissionReportType}
          handleArchiveLog={handleArchiveApi}
        />
        {loading ? (
          <LoaderCnt>
            <CircularProgress />
          </LoaderCnt>
        ) : (
          <FlaggedItemsDetails rowData={tableData} onRowClick={onRowClick} />
        )}
      </ContentCnt>
    </CustomDialog>
  );
}

export default FlaggedItemsTableChartDialog;
